const TAGS = {
  Homepage: { value: 'Homepage', title: 'Homepage' },
  Web: { value: 'Web', title: 'Web' },
  News: { value: 'News', title: 'News' },
  Images: { value: 'Images', title: 'Images' },
  Footer: { value: 'Footer', title: 'Footer' },
  Widget: { value: 'Widget', title: 'Widget' },
  Snippet: { value: 'Snippet', title: 'Snippet' },
  InfoBox: { value: 'InfoBox', title: 'InfoBox' },
  KnowledgeGraph: { value: 'KnowledgeGraph', title: 'KnowledgeGraph' },
  Other: { value: 'Other', title: 'Other' },
};

export default [
  {
    src: "/portfolio/images/serp/WeatherMunich.png",
    thumbnail: "/portfolio/images/serp/WeatherMunich_tn.png",
    thumbnailWidth: 271,
    thumbnailHeight: 180,
    tags: [TAGS.Web, TAGS.Snippet],
    caption: "Smart Result: Weather"
  },
  {
    src: "/portfolio/images/serp/Homepage1.png",
    thumbnail: "/portfolio/images/serp/Homepage1_tn.png",
    thumbnailWidth: 254,
    thumbnailHeight: 180,
    tags: [TAGS.Homepage],
    caption: "Homepage: Dark Theme"
  },
  {
    src: "/portfolio/images/serp/Homepage2.png",
    thumbnail: "/portfolio/images/serp/Homepage2_tn.png",
    thumbnailWidth: 254,
    thumbnailHeight: 180,
    tags: [TAGS.Homepage],
    caption: "Homepage: Query Suggestions"
  },
  {
    src: "/portfolio/images/serp/HomepageWhite.png",
    thumbnail: "/portfolio/images/serp/HomepageWhite_tn.png",
    thumbnailWidth: 254,
    thumbnailHeight: 180,
    tags: [TAGS.Homepage],
    caption: "Homepage: Light Theme"
  },
  {
    src: "/portfolio/images/serp/BigBang.png",
    thumbnail: "/portfolio/images/serp/BigBang_tn.png",
    thumbnailWidth: 271,
    thumbnailHeight: 180,
    tags: [TAGS.Web, TAGS.InfoBox],
    caption: "InfoBox"
  },
  {
    src: "/portfolio/images/serp/Coronavirus.png",
    thumbnail: "/portfolio/images/serp/Coronavirus_tn.png",
    thumbnailWidth: 254,
    thumbnailHeight: 180,
    tags: [TAGS.Web, TAGS.InfoBox],
    caption: "InfoBox"
  },
  {
    src: "/portfolio/images/serp/Flight.jpg",
    thumbnail: "/portfolio/images/serp/Flight_tn.jpg",
    thumbnailWidth: 316,
    thumbnailHeight: 180,
    tags: [TAGS.Web, TAGS.Snippet],
    caption: "Smart Result: Flight"
  },
  {
    src: "/portfolio/images/serp/NewsResult.jpg",
    thumbnail: "/portfolio/images/serp/NewsResult_tn.jpg",
    thumbnailWidth: 316,
    thumbnailHeight: 180,
    tags: [TAGS.Web, TAGS.News],
    caption: "Smart Result: News"
  },
  {
    src: "/portfolio/images/serp/PrivacyStats.png",
    thumbnail: "/portfolio/images/serp/PrivacyStats_tn.png",
    thumbnailWidth: 254,
    thumbnailHeight: 180,
    tags: [TAGS.Web],
    caption: "Privacy: Trackers"
  },
  {
    src: "/portfolio/images/serp/RichResults.gif",
    thumbnail: "/portfolio/images/serp/RichResults_tn.gif",
    thumbnailWidth: 316,
    thumbnailHeight: 180,
    tags: [TAGS.Web, TAGS.Snippet],
    caption: "Smart Results"
  },
  {
    src: "/portfolio/images/serp/Settings.png",
    thumbnail: "/portfolio/images/serp/Settings_tn.png",
    thumbnailWidth: 254,
    thumbnailHeight: 180,
    tags: [TAGS.Homepage],
    caption: "Homepage: Settings"
  },
  {
    src: "/portfolio/images/serp/Soccer.jpg",
    thumbnail: "/portfolio/images/serp/Soccer_tn.jpg",
    thumbnailWidth: 316,
    thumbnailHeight: 180,
    tags: [TAGS.Web, TAGS.Snippet],
    caption: "Smart Result: Soccer"
  },
  {
    src: "/portfolio/images/serp/SoccerStandings.jpg",
    thumbnail: "/portfolio/images/serp/SoccerStandings_tn.jpg",
    thumbnailWidth: 316,
    thumbnailHeight: 180,
    tags: [TAGS.Web, TAGS.Snippet],
    caption: "Smart Result: Soccer (Standings)"
  },
  {
    src: "/portfolio/images/serp/TimBerners.png",
    thumbnail: "/portfolio/images/serp/TimBerners_tn.png",
    thumbnailWidth: 271,
    thumbnailHeight: 180,
    tags: [TAGS.Web, TAGS.InfoBox],
    caption: "InfoBox"
  },
  {
    src: "/portfolio/images/serp/TimeCanada.png",
    thumbnail: "/portfolio/images/serp/TimeCanada_tn.png",
    thumbnailWidth: 271,
    thumbnailHeight: 180,
    tags: [TAGS.Web, TAGS.Snippet],
    caption: "Smart Result: Time"
  },
  {
    src: "/portfolio/images/serp/Cinemaxx.jpg",
    thumbnail: "/portfolio/images/serp/Cinemaxx_tn.jpg",
    thumbnailWidth: 469,
    thumbnailHeight: 180,
    tags: [TAGS.Web, TAGS.Snippet],
    caption: "Smart Result: Cinema"
  },
  {
    src: "/portfolio/images/serp/RiversEurope.jpg",
    thumbnail: "/portfolio/images/serp/RiversEurope_tn.jpg",
    thumbnailWidth: 312,
    thumbnailHeight: 180,
    tags: [TAGS.Web, TAGS.KnowledgeGraph],
    caption: "Europe Rivers Knowledge Graph"
  },
  {
    src: "/portfolio/images/serp/WhoTracksMe.jpg",
    thumbnail: "/portfolio/images/serp/WhoTracksMe_tn.jpg",
    thumbnailWidth: 271,
    thumbnailHeight: 180,
    tags: [TAGS.Web, TAGS.Snippet],
    caption: "Trackers Info Popup"
  },
  {
    src: "/portfolio/images/serp/Widgets.png",
    thumbnail: "/portfolio/images/serp/Widgets_tn.png",
    thumbnailWidth: 310,
    thumbnailHeight: 180,
    tags: [TAGS.Homepage, TAGS.Widget],
    caption: "Homepage: Widgets"
  },
  {
    src: "/portfolio/images/serp/FoamTree.jpg",
    thumbnail: "/portfolio/images/serp/FoamTree_tn.jpg",
    thumbnailWidth: 317,
    thumbnailHeight: 180,
    tags: [TAGS.Other],
    caption: "Source code: Modules"
  },
];